// This handles an object which can be deactivated!
// Firestore stores the deactivated date as a number, and "0" means active!

// This is what we store in the DB
export type Deactivatable = {
  deactivated: number; // If we deactivate the item - we set this date; otherwise it must be "0" (can't be missing - see: https://stackoverflow.com/questions/52431050/firestore-select-where-a-field-is-not-present)
};

export function isActive(item: Deactivatable | undefined): boolean {
  if (!item) return false;
  return item.deactivated === 0; // If the field doesn't exist - we treat it as not active!!! So that its explicitly written to the DB!
}

export function setDeactive<T>(item: T): T & Deactivatable {
  return { ...item, deactivated: Date.now() };
}

export function setActive<T>(item: T): T & Deactivatable {
  return { ...item, deactivated: 0 };
}

export function deactivableComparator(a: Deactivatable, b: Deactivatable): number {
  return a.deactivated - b.deactivated; // This will put "0" deactivated first
}
